const recipients = [{
    path: '/recipients',
    name: 'Recipients',
    meta: {
        auth: true,
    },
    component: () => 
        import(/* webpackChunkName: "Recipients" */ '@/views/recipients/Recipients'),
    children: [
        {
            path: 'list',
            name: 'recipients-list',
            meta: {
                auth: true,
            },
            component: () => 
                import(/* webpackChunkName: "Recipients List" */ '@/views/recipients/List'),
        },
        {
            path: 'add',
            redirect: { name: 'recipients-list' },
        },                
    ]
}]

export {recipients}